import React from "react";
import { userActivityLogger } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";

interface IContactSupportBox{
  contact: string;
  message: string
}

const ContactSupportBox = ({ contact, message } : IContactSupportBox) => {
  return (
    <div onClick={() => userActivityLogger(MIXPANEL_EVENTS.UPDATE_HOSPITAL_SUPPORT, {})}
      className="flex flex-col justify-center items-center
        border border-taupe-2 rounded-xl p-5 gap-[0.63rem] cursor-default">
      <div className="text-sm">{message}</div>
      <a
        href={contact} className="text-sm bg-taupe-2 w-11/12 py-3 px-8 rounded-[6.25rem] text-center font-semibold
      cursor-pointer hover:bg-gray-4">
        Contact Support
      </a>
    </div>
  );
};

export default ContactSupportBox;
